import React from 'react';

function ProfileSettings() {
  return (<>Profile settings</>)
}

export default ProfileSettings;
